
export class StandardRowAction {

    public actionJSON: any = {};

    constructor(actionObject: any) {
        this.formActionJSON(actionObject);
    }


    formActionJSON(actionObject: any) {
        if (actionObject.isRuleApplied) {
            if (actionObject.isVisible === 'true') {
                this.actionJSON = {
                    rowFormRules: {
                        [actionObject.name]: {
                            fields: actionObject.visibilityRuleFields,
                            ...actionObject.visibilityRuleObj
                        }
                    }
                }
            } else {
                this.actionJSON = {
                    rowFormRules: {
                        [actionObject.name]: actionObject.visibilityRuleObj
                    }
                }
            }
        } 
        // else {
        //     this.actionJSON = {
        //         rowActions: {
        //             label: actionObject.label,
        //             name: actionObject.name,
        //         }
        //     }
        // }
        return this.actionJSON;
    }


}